var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _vm._v(" Attentie gevraagd: "),
    _c(
      "ul",
      { staticClass: "attentions" },
      _vm._l(_vm.attentions, function (at, i) {
        return _c(
          "li",
          {
            key: i,
            class: { forMe: _vm.attentionForMe(at) },
            attrs: { value: at },
          },
          [
            _c(
              "w-link",
              {
                class: { read: at.read, others: !_vm.attentionForMe(at) },
                on: {
                  click: function ($event) {
                    return _vm.triggerToggleAsRead(at)
                  },
                },
              },
              [_vm._v(_vm._s(at.admin.name))]
            ),
            _vm._v(" " + _vm._s(_vm.addComma(i)) + " "),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }